import { gql } from '@apollo/client';

import { FragmentGarageVehicle } from '../../fragments/garage';

export const QueryGarageVehicles = gql`
  query GarageVehicles {
    garageVehicles {
      ...FragmentGarageVehicle
    }
  }
  ${FragmentGarageVehicle}
`;
